import './App.scss';

import React, { useEffect, useState } from 'react';

import { About } from './components/About';
import { Experience } from './components/Experience';
import { Contact } from './components/Contact';
import { Header } from './components/Header';
import JsonData from './data/data.json';
// import { Links } from './components/Links';
import { Navigation } from './components/Navigation';
import { Education } from './components/Education';
import SmoothScroll from 'smooth-scroll';
import { ProfessionalDevelopment } from './components/ProfessionalDevelopment';

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      {/* <Links data={landingPageData.Links} /> */}
      <About data={landingPageData.About} />
      <Education data={landingPageData.Education} />
      <ProfessionalDevelopment data={landingPageData.ProfessionalDevelopment} />
      <Experience data={landingPageData.Experience} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
